export const TOGGLE_LANGUAGE = 'TOGGLE_LANGUAGE';
export const SET_PERMISSION = 'SET_PERMISSION';
export const SET_ACCOUNTINFO = 'SET_ACCOUNTINFO';
export const SET_PAGETITLE = 'SET_PAGETITLE';
export const SET_GLOBAL_SETTING = 'SET_GLOBAL_SETTING';
export const RESET_USER = 'RESET_USER';
export const SET_TEAMS_GLOBAL = 'SET_TEAMS_GLOBAL';
export const SET_LOGO = 'SET_LOGO';
export const RESET_VIEW_GLOBAL = 'RESET_VIEW';
export const SET_USERS_GLOBAL = 'SET_USERS_GLOBAL';
export const SET_APP_ROUTER_HASH = 'SET_APP_ROUTER_HASH';
export const SET_TIME_ZONE = 'SET_TIME_ZONE';
export const SET_THEME = 'SET_THEME';


// WEBPACK FOOTER //
// ./src/store/global/actionType.js